import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { IWorkerNew } from 'types';
import { newCustomStyles } from 'components';
import { ISelectValue } from 'components/ui';
import { StyledSelect } from './worker-select.styled';

interface IProps {
  collapsed: boolean;
}

export const WorkerSelect = observer(({ collapsed }: IProps) => {
  const { workers, createRequest, telephony, aiRequests } = useStore();
  const { applicant } = createRequest;

  const workersList = () => {
    return workers
      .getAllWorkers()
      .filter((worker) => worker.has_access)
      .map((worker: any) => {
        return {
          department: {
            name: worker.department.name || '',
            provider: worker.department.id || '',
          },
          email: worker?.email || null,
          id: worker.id,
          inn: worker?.inn || null,
          number: '',
          phones: worker.phones || [],
          position: { name: worker.position.name || '' },
          short_name: worker.short_name || '',
          str_name: worker.str_name || '',
          _type: ['Worker'],
        };
      });
  };

  const prepareWorkersForSelect = () => {
    return (
      allWorkers
        .map((worker: IWorkerNew) => {
          return {
            label: worker.short_name,
            value: worker.id,
          };
        })
        .filter((worker: { [key: string]: any }): boolean => !!worker.label) ||
      []
    );
  };

  const allWorkers: IWorkerNew[] = useMemo(workersList, [
    workers.departments.length,
  ]);

  const workersOptions: ISelectValue[] = useMemo(prepareWorkersForSelect, [
    allWorkers.length,
  ]);

  const selectedWorker = useMemo(() => {
    return (
      workersOptions.find(
        (item: { [key: string]: any }): boolean =>
          item.value === applicant.workerId
      ) || ''
    );
  }, [applicant.workerId, workersOptions]);

  const handleChangeWorker = (workerId: string): void => {
    if (!selectedWorker || workerId !== selectedWorker?.value) {
      const currentWorker: IWorkerNew = allWorkers.find(
        (worker: IWorkerNew): boolean => worker.id === workerId
      )!;
      applicant.editWorkersList(
        currentWorker,
        createRequest.lastValidPhoneNumber
      );
      applicant.setSelectedId('workerId', workerId);

      telephony.callerInfo.setCallerInfo(
        currentWorker.str_name,
        currentWorker.email || '',
        currentWorker.phones[0]?.str_number || createRequest.initialPhoneNumber,
        '',
        ''
      );
    }
  };

  return (
    <StyledSelect
      collapsed={collapsed}
      styles={newCustomStyles}
      options={workersOptions}
      placeholder="ФИО сотрудника"
      menuPortalTarget={document.body}
      closeMenuOnScroll={true}
      closeMenuOnSelect={true}
      className="worker"
      classNamePrefix="worker"
      menuPlacement="auto"
      isMulti={false}
      value={selectedWorker}
      onChange={(newValue: any) => handleChangeWorker(newValue.value)}
      isDisabled={aiRequests.isAiMode}
    />
  );
});
